import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class TextInput extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    icon: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.bool,
    ]),
    label: PropTypes.string,
    name: PropTypes.string,
    onBlur: PropTypes.func,
    onKeyPress: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    showErrors: PropTypes.bool,
    specialClass: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    validationErrors: PropTypes.array,
    dataTestId: PropTypes.string,
  }

  static defaultProps = {
    disabled: false,
    icon: false,
    onBlur: () => {},
    onKeyPress: () => {},
    onChange: () => {},
    showErrors: true,
    validationErrors: [],
    value: '',
    dataTestId: '',
  }

  render() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'disabled' does not exist on type 'Readon... Remove this comment to see the full error message
    const {disabled, icon, id, onBlur, onKeyPress, onChange, placeholder, showErrors, specialClass, type, validationErrors, value, dataTestId} = this.props;
    const className = classNames({
      ['input--text']: true,
      [`input--text__${specialClass}`]: !!specialClass,
      ['has-icon']: !!icon,
      ['has-error']: showErrors && validationErrors.length > 0,
    });
    const textInputProps = Object.assign({
      className,
      disabled,
      id,
      onBlur,
      onKeyPress,
      onChange,
      placeholder,
      type,
      value,
    });

    return (
      <div className="input--text-container">
        {icon ? <span className={`icon icon-${icon}`} /> : null}
        <input {...textInputProps} data-test-id={dataTestId} />
        <ul className="input--text__validation-list">
          {showErrors && validationErrors.map((error) =>
            <li className="input--text__validation-warning" key={error}>{error}</li>)}
        </ul>
      </div>
    );
  }
}
